import * as React from "react";
import { createRoot } from "react-dom/client";
import { AppRoutes } from "./AppRoutes";
// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyA56n2XXA58v2ErX0-BvUoB217IZiEumzg",
  authDomain: "nurse-test-c79e9.firebaseapp.com",
  projectId: "nurse-test-c79e9",
  storageBucket: "nurse-test-c79e9.firebasestorage.app",
  messagingSenderId: "169817277877",
  appId: "1:169817277877:web:a8734a8a9179284e2b05fc",
  measurementId: "G-WWGRFW40P1",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const App = (): React.JSX.Element => {
  return (
    <React.StrictMode>
      <AppRoutes />
    </React.StrictMode>
  );
};

const container = document.querySelector("#app");
const root = createRoot(container!);
root.render(<App />);
